module.exports = __webpack_public_path__ + "static/media/watch-active.b324e39d.svg";